import { compose } from '@beef/utils';
import { getContent } from "../../../../../dependencies/getContent/dev";
import { sendSberpayPayment } from "../../../../../dependencies/submitPayment/methods/sberpay/index.regular";
import { withOnScreenAnalytics } from "../../../../../../utils/withOnScreenAnalytics";
import { getWindow } from "../../../../../../utils/window";
import { getAccountType } from "../../../../../../utils/analytics";
import { ymPushParams } from "../../../../../../utils/ym.alternative";
import { getMapStateToSberPayModalProps } from "./logic/logic";
import { mapStateToSberPayCaptchaInputProps } from "./components/Captcha";
import { refreshCaptcha } from "./components/Captcha/dependencies/refreshCaptcha/dev";
import { getOnScreenAnalyticsHandler } from "./analytics/analytics";
import { SberPayModal as _SberPayModal } from "./SberPayModal";
/**
 * Set up dependencies for the sberpay modal state mapping.
 *
 * NOTE: Index files are responsible for connecting dependencies to their respective logic
 * This approach uses a hierarchical composition pattern, where dependencies are organized
 * at the same level as their corresponding components. This keeps the codebase modular
 * and easier to maintain.
 * The top-level index.ts file gathers dependencies from the index.ts files of other components
 * and composes them following the same hierarchy as the components.
 * */
export var mapStateToSberPayModalProps = getMapStateToSberPayModalProps({
  getContent: getContent,
  submitSberPayPayment: sendSberpayPayment,
  mapStateToSberPayCaptchaInputProps: mapStateToSberPayCaptchaInputProps,
  refreshCaptcha: refreshCaptcha
});
export var SberPayModal = compose(withOnScreenAnalytics(getOnScreenAnalyticsHandler({
  getWindow: getWindow,
  getAccountType: getAccountType,
  ymPushParams: ymPushParams
}), {
  shouldTriggerOnce: true,
  debounce: 100
}))(_SberPayModal);